import { useTranslation } from 'react-i18next';

import { setLanguage, SUPPORTED_LANGUAGES, type Language } from '@/shared/i18n';

/** Minimal ru/en switch. Replaced by a proper settings control in the profile phase. */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const current = (SUPPORTED_LANGUAGES as readonly string[]).includes(i18n.language)
    ? (i18n.language as Language)
    : 'ru';

  return (
    <button
      type="button"
      onClick={() => {
        setLanguage(current === 'ru' ? 'en' : 'ru');
      }}
      aria-label={t('common.language')}
      className="grid h-10 min-w-10 place-items-center rounded-pill px-3 text-body-sm font-semibold text-[var(--text-secondary)] uppercase transition-colors hover:bg-[var(--surface-hover)] hover:text-[var(--text-primary)]"
    >
      {current}
    </button>
  );
}
